import React, { useEffect, useState } from "react";
import "./Scene.css";
import { Cloud } from "./Cloud"; 
import { GrassPatch } from "./GrassPatch";
import Stars from "./Stars";
import { useScene } from "./SceneContext";

export default function Scene() {
    const [isMobile, setIsMobile] = useState(false);
    const publicUrl = process.env.PUBLIC_URL || "";
    const { variant: ctxVariant } = useScene();
    const variant = ctxVariant;

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize(); // 初始判断
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={`scene scene--${variant}${isMobile ? " scene--mobile" : ""}`}>
            <div className="mountains"
                style={{ backgroundImage: `url('${publicUrl}/assets/mountains.svg')` }}
            />
            <div className="trees" />
            {variant === "night" ? (
              <Stars />
            ) : (
              <>
                {/* Cloud Distribution */}
                <Cloud left={isMobile ? "8%" : "10%"} top="5%" delay={0} size={isMobile ? 120 : 150} />
                {isMobile ? null : (
                  <>
                    <Cloud left="40%" top="8%" size={180} delay={10} />
                    <Cloud left="70%" top="3%" size={120} delay={20} />
                  </>
                )}
              </>
            )}

            {/* Grass patches */}
            <GrassPatch left="8%" bottom="0" />
            <GrassPatch left="32%" bottom="0" scale={isMobile ? 1 : 1.2} />
            {isMobile ? null : (
              <>
                <GrassPatch left="55%" bottom="0" />
                <GrassPatch left="80%" bottom="0" scale={0.8} />
              </>
            )}
            {variant === "night" ? null : (
              <div
                className="sun"
                style={{ backgroundImage: `url('${publicUrl}/assets/sun.svg')` }}
              />
            )}
            <div className="banners" />
        </div>
    );
}
